import axiosClient from "./axiosClient";

export const registerUser = async ({ email, password }) => {
  const response = await axiosClient.post("/users/register", {
    email,
    password,
  });

  return response.data;
};

export const signInUser = async ({ email, password }) => {
  const response = await axiosClient.post("/users/signin", {
    email,
    password,
  });

  return response.data;
};

export const signOutUser = async ({ uid } = {}) => {
  if (!uid) {
    throw new Error("uid is required for sign out.");
  }

  const response = await axiosClient.post("/users/logout", { uid });
  return response.data;
};

export const registerGoogleUser = async ({ credential, mode }) => {
  const { data } = await axiosClient.post("/users/google-signin", {
    credential,
    mode,
  });

  return data;
};

export const initializeUserAccount = async ({
  uid,
  email,
  plan = "freemium",
}) => {
  const response = await axiosClient.post("/users/init", {
    uid,
    email,
    plan,
  });

  return response.data;
};

export const getUserProfile = async (uid) => {
  const response = await axiosClient.get(`/users/${uid}`);
  return response.data;
};

export const getUserPlan = async (uid) => {
  const response = await axiosClient.get(`/users/${uid}/plan`);
  return response.data;
};

export const syncVerifiedUserProfile = async (email) => {
  const response = await axiosClient.post("/users/verify-email", {
    email,
  });

  return response.data;
};

export const deleteCurrentUserAccount = async (uid) => {
  if (!uid) {
    throw new Error("uid is required to delete account.");
  }

  const response = await axiosClient.delete(`/users/${uid}`);
  return response.data;
};

export const resetUserPassword = async ({ email, password, newPassword }) => {
  try {
    const response = await axiosClient.post("/users/reset-password", {
      email,
      password,
      newPassword,
    });

    return response.data;
  } catch (error) {
    console.error("[USERS API ERROR] POST /users/reset-password", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    throw error;
  }
};
